let videos = document.querySelectorAll('.block_image_video .play-button');

videos.forEach(function (el) {
    el.addEventListener('click', function () {
        this.parentElement.classList.add('play');
        this.nextElementSibling.play();
    });
});
